/**
 * Retrieves the duration of multiple video files in parallel.
 *
 * @param {File[]} files - Array of video files to extract duration from.
 * @returns {Promise<number[]>} A promise that resolves to an array of durations in seconds,
 * in the same order as the input files.
 *
 * @example
 * const input = document.querySelector('input[type="file"]');
 * input.addEventListener('change', async (e) => {
 *   const files = Array.from(e.target.files);
 *   const durations = await getVideoDuration(files);
 *   console.log(durations); // [12.34, 45.67, 8.91]
 * });
 */
export async function getVideoDuration(file: File): Promise<number> {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.preload = 'metadata';

        video.onloadedmetadata = () => {
            URL.revokeObjectURL(video.src);
            resolve(video.duration);
        };

        video.onerror = () => reject(`Failed to load metadata for file: ${file.name}`);

        video.src = URL.createObjectURL(file);
    });
}
